
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import ProgressBar from '@/features/shipment/components/shipmentSuccess/instructions/ProgressBar.vue';
import LottieAnimation from '@/features/common/components/LottieAnimation.vue';

@Component({
  components: {
    ProgressBar,
    LottieAnimation,
  },
})
export default class Insurance extends Vue {
  @Prop({ required: true }) step!: number;

  @Watch('step', { immediate: true })
  private async startInstructionsAnimation(step: number) {
    await this.$nextTick();

    const media = document.querySelector('#insuranceMedia') as HTMLVideoElement;
    if (!media) return;

    if (step === 2) {
      media.play();
    } else {
      media.pause();
      media.currentTime = 0;
    }
  }
}
